<script lang="ts">
	import type { HTMLTextareaAttributes } from "svelte/elements";
	import { updateTextareaHeight } from "@core/utils/updateTextareaHeight.js";

	const { ...rest }: HTMLTextareaAttributes = $props();
</script>

<textarea
	use:updateTextareaHeight
	{...rest}
	class={[
		"min-w-0 block shadow-sm transition-[outline,color] duration-300 !outline-none border-[1.5px] resize-none",
		"text-cmctext placeholder:text-cmcmidgray font-semibold tracking-[0.02em] bg-white",
		"focus:border-cmcprimary min-h-6 md:min-h-12 rounded-lg md:rounded-xl border-cmcmidgray text-2xs/3 md:text-base/tight px-2 md:px-4 py-2 md:py-3.5",
		rest.class,
	]}
></textarea>
